<template>

    <div v-if="contentWidth > 800 || (contentWidth <= 800 && showMobileMenu)" :class="['sidebarNav', { 'collapsed': isCollapsed }]" aria-label="Site sidebar navigation">
        <nav class="main-nav">
            <div class="main-nav-content">
                <div class="main-nav-content-inner logo">
                    <div class="main-nav-logo">
                        <router-link to="/" class="cs-logo" @mouseenter="prefetchRouteByPath('/')">
                            <!-- Full logo -->
                            <svg v-if="!isCollapsed" width="127" height="28" viewBox="0 0 127 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M30.9915 4.00459C30.5115 3.33111 29.8867 2.76989 29.1615 2.3608C24.1578 -0.57761 14.1944 2.25488 6.9182 8.68487C0.798199 14.0909 -1.45444 20.3169 0.937743 23.9066C1.42224 24.6184 2.06598 25.2115 2.81959 25.6406C6.40786 27.7355 12.484 26.892 18.3249 23.9105C20.7611 22.6627 23.0288 21.1194 25.0748 19.3165C31.2467 13.8712 33.5033 7.59424 30.9915 4.00459ZM23.2169 18.0925C21.5747 19.4833 19.7642 20.6692 17.8265 21.6233C13.1339 23.9497 8.20599 24.5029 5.42308 22.9807C4.8261 22.6578 4.31622 22.1991 3.93594 21.6429C2.02619 18.8654 3.86817 14.0556 8.77612 9.87357C14.6091 4.91083 22.575 2.72173 26.566 4.98929C27.1342 5.30613 27.6265 5.73965 28.0093 6.26038C29.9988 9.02618 28.1687 13.8712 23.2169 18.0925Z" fill="#0077BD"/>
                                <path d="M28.5142 6.96265H16.1653C16.1653 6.96265 15.0872 10.262 14.0851 13.3456V13.3769L12.3536 18.579L4.12909 20.9329H16.7305L20.5261 9.29298L28.5142 6.96265Z" fill="#0077BD"/>
                                <path d="M42.68 21H39.368V9.096H42.68V21ZM41.024 7.464C40.512 7.464 40.08 7.288 39.728 6.936C39.376 6.584 39.2 6.152 39.2 5.64C39.2 5.128 39.376 4.696 39.728 4.344C40.08 3.976 40.512 3.792 41.024 3.792C41.536 3.792 41.968 3.976 42.32 4.344C42.672 4.696 42.848 5.128 42.848 5.64C42.848 6.152 42.672 6.584 42.32 6.936C41.968 7.288 41.536 7.464 41.024 7.464ZM51.3423 9.096C51.7903 9.096 52.2863 9.16 52.8303 9.288C53.3743 9.416 53.8863 9.656 54.3663 10.008C54.8463 10.36 55.2463 10.848 55.5663 11.472C55.9023 12.096 56.0703 12.904 56.0703 13.896V21H52.7343V14.016C52.7343 13.648 52.6703 13.336 52.5423 13.08C52.4303 12.824 52.2703 12.624 52.0623 12.48C51.8703 12.32 51.6463 12.208 51.3903 12.144C51.1343 12.064 50.8783 12.024 50.6223 12.024C50.4143 12.024 50.1823 12.064 49.9263 12.144C49.6863 12.208 49.4543 12.32 49.2303 12.48C49.0223 12.64 48.8463 12.848 48.7023 13.104C48.5583 13.36 48.4863 13.664 48.4863 14.016V21H45.1743V9.096H48.0063L48.4863 10.008C48.8703 9.736 49.3023 9.52 49.7823 9.36C50.2623 9.184 50.7823 9.096 51.3423 9.096ZM62.5267 16.728C62.5267 17.288 62.6947 17.72 63.0307 18.024C63.3827 18.328 63.8387 18.48 64.3987 18.48C64.8467 18.48 65.2947 18.392 65.7427 18.216V21C65.3427 21.128 64.9187 21.232 64.4707 21.312C64.0227 21.408 63.5747 21.456 63.1267 21.456C62.6147 21.456 62.1267 21.392 61.6627 21.264C61.1987 21.136 60.7827 20.92 60.4147 20.616C60.0467 20.296 59.7507 19.88 59.5267 19.368C59.3187 18.84 59.2147 18.192 59.2147 17.424V12.048H57.5107V9.816L59.2147 9.096V6.432H62.5267V9.096H65.7427V12.048H62.5267V16.728ZM70.5862 10.752C70.7462 10.496 70.9302 10.256 71.1382 10.032C71.3462 9.792 71.5942 9.584 71.8822 9.408C72.1702 9.216 72.4982 9.064 72.8662 8.952C73.2342 8.84 73.6502 8.784 74.1142 8.784C74.6582 8.784 75.2902 8.88 76.0102 9.072L75.6982 12.024C75.5222 11.992 75.3462 11.952 75.1702 11.904C75.0262 11.872 74.8662 11.848 74.6902 11.832C74.5142 11.8 74.3542 11.784 74.2102 11.784C73.6982 11.784 73.2182 11.856 72.7702 12C72.3382 12.144 71.9622 12.344 71.6422 12.6C71.3222 12.856 71.0662 13.168 70.8742 13.536C70.6822 13.888 70.5862 14.272 70.5862 14.688V21H67.2742V9.096H70.2742L70.5862 10.752ZM89.6688 9.096V21H86.8128L86.4768 19.728C86.0128 20.352 85.4528 20.768 84.7968 20.976C84.1568 21.184 83.4848 21.288 82.7808 21.288C81.9328 21.288 81.1488 21.128 80.4288 20.808C79.7248 20.472 79.1088 20.024 78.5808 19.464C78.0528 18.888 77.6368 18.224 77.3328 17.472C77.0448 16.704 76.9008 15.888 76.9008 15.024C76.9008 14.16 77.0448 13.352 77.3328 12.6C77.6368 11.832 78.0528 11.168 78.5808 10.608C79.1088 10.032 79.7248 9.584 80.4288 9.264C81.1488 8.928 81.9328 8.76 82.7808 8.76C83.5488 8.76 84.2528 8.88 84.8928 9.12C85.5328 9.36 86.0608 9.744 86.4768 10.272L86.8128 9.096H89.6688ZM86.3568 15.072C86.3568 14.448 86.2688 13.928 86.0928 13.512C85.9328 13.08 85.7088 12.736 85.4208 12.48C85.1488 12.208 84.8208 12.016 84.4368 11.904C84.0688 11.776 83.6688 11.712 83.2368 11.712C82.8048 11.712 82.3968 11.8 82.0128 11.976C81.6448 12.152 81.3168 12.392 81.0288 12.696C80.7408 12.984 80.5168 13.336 80.3568 13.752C80.1968 14.152 80.1168 14.576 80.1168 15.024C80.1168 15.488 80.1968 15.92 80.3568 16.32C80.5168 16.72 80.7408 17.072 81.0288 17.376C81.3168 17.664 81.6448 17.896 82.0128 18.072C82.3968 18.248 82.8048 18.336 83.2368 18.336C84.1008 18.336 84.8288 18.072 85.4208 17.544C86.0288 17 86.3408 16.176 86.3568 15.072ZM98.0064 9.096C98.4544 9.096 98.9504 9.16 99.4944 9.288C100.038 9.416 100.55 9.656 101.03 10.008C101.51 10.36 101.91 10.848 102.23 11.472C102.566 12.096 102.734 12.904 102.734 13.896V21H99.3984V14.016C99.3984 13.648 99.3344 13.336 99.2064 13.08C99.0944 12.824 98.9344 12.624 98.7264 12.48C98.5344 12.32 98.3104 12.208 98.0544 12.144C97.7984 12.064 97.5424 12.024 97.2864 12.024C97.0784 12.024 96.8464 12.064 96.5904 12.144C96.3504 12.208 96.1184 12.32 95.8944 12.48C95.6864 12.64 95.5104 12.848 95.3664 13.104C95.2224 13.36 95.1504 13.664 95.1504 14.016V21H91.8384V9.096H94.6704L95.1504 10.008C95.5344 9.736 95.9664 9.52 96.4464 9.36C96.9264 9.184 97.4464 9.096 98.0064 9.096ZM110.679 8.76C111.575 8.76 112.391 8.944 113.127 9.312C113.863 9.664 114.495 10.136 115.023 10.728C115.551 11.304 115.959 11.976 116.247 12.744C116.535 13.496 116.679 14.272 116.679 15.072C116.679 15.552 116.615 16.064 116.487 16.608H107.991C108.311 17.152 108.767 17.616 109.359 18C109.951 18.368 110.591 18.552 111.279 18.552C111.967 18.552 112.567 18.496 113.079 18.384C113.607 18.272 114.103 18.128 114.567 17.952L115.671 19.992C115.079 20.408 114.399 20.728 113.631 20.952C112.879 21.176 112.071 21.288 111.207 21.288C110.263 21.288 109.383 21.128 108.567 20.808C107.751 20.472 107.039 20.024 106.431 19.464C105.823 18.904 105.343 18.24 104.991 17.472C104.639 16.704 104.463 15.888 104.463 15.024C104.463 14.176 104.623 13.376 104.943 12.624C105.263 11.856 105.703 11.192 106.263 10.632C106.839 10.056 107.503 9.6 108.255 9.264C109.007 8.928 109.815 8.76 110.679 8.76ZM113.391 14.04C113.199 13.352 112.855 12.792 112.359 12.36C111.863 11.928 111.303 11.712 110.679 11.712C110.039 11.712 109.455 11.928 108.927 12.36C108.415 12.792 108.063 13.352 107.871 14.04H113.391ZM123.464 16.728C123.464 17.288 123.632 17.72 123.968 18.024C124.32 18.328 124.776 18.48 125.336 18.48C125.784 18.48 126.232 18.392 126.68 18.216V21C126.28 21.128 125.856 21.232 125.408 21.312C124.96 21.408 124.512 21.456 124.064 21.456C123.552 21.456 123.064 21.392 122.6 21.264C122.136 21.136 121.72 20.92 121.352 20.616C120.984 20.296 120.688 19.88 120.464 19.368C120.256 18.84 120.152 18.192 120.152 17.424V12.048H118.448V9.816L120.152 9.096V6.432H123.464V9.096H126.68V12.048H123.464V16.728Z" fill="#0077BD"/>
                            </svg>
                            <!-- Icon only logo for collapsed state -->
                            <svg v-else width="32" height="28" viewBox="0 0 32 28" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M30.9915 4.00459C30.5115 3.33111 29.8867 2.76989 29.1615 2.3608C24.1578 -0.57761 14.1944 2.25488 6.9182 8.68487C0.798199 14.0909 -1.45444 20.3169 0.937743 23.9066C1.42224 24.6184 2.06598 25.2115 2.81959 25.6406C6.40786 27.7355 12.484 26.892 18.3249 23.9105C20.7611 22.6627 23.0288 21.1194 25.0748 19.3165C31.2467 13.8712 33.5033 7.59424 30.9915 4.00459ZM23.2169 18.0925C21.5747 19.4833 19.7642 20.6692 17.8265 21.6233C13.1339 23.9497 8.20599 24.5029 5.42308 22.9807C4.8261 22.6578 4.31622 22.1991 3.93594 21.6429C2.02619 18.8654 3.86817 14.0556 8.77612 9.87357C14.6091 4.91083 22.575 2.72173 26.566 4.98929C27.1342 5.30613 27.6265 5.73965 28.0093 6.26038C29.9988 9.02618 28.1687 13.8712 23.2169 18.0925Z" fill="#0077BD"/>
                                <path d="M28.5142 6.96265H16.1653C16.1653 6.96265 15.0872 10.262 14.0851 13.3456V13.3769L12.3536 18.579L4.12909 20.9329H16.7305L20.5261 9.29298L28.5142 6.96265Z" fill="#0077BD"/>
                            </svg>
                        </router-link>
                        <!-- Collapse toggle button -->
                        <button @click="toggleCollapse" class="collapse-toggle" :title="isCollapsed ? $t('Expand menu') : $t('Collapse menu')">
                            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path v-if="!isCollapsed" d="M11 19L4 12L11 5M4 12H20" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                <path v-else d="M13 5L20 12L13 19M20 12H4" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>
                    </div>
                    <ul class="main-nav-list">
                        <template v-for="route in filteredRoutes" :key="route.name">
                        <!-- "MY SPACES" overline before the first Space entry -->
                        <li
                            v-if="route.meta?.isFirstSpace && !isCollapsed"
                            class="main-nav-spaces-overline"
                            aria-hidden="true"
                        >
                            <span>{{ $t('My workgroups') }}</span>
                        </li>

                        <!-- Space card variant -->
                        <li
                            v-if="route.meta?.isSpace && hasAccessToRoute(route) && !isCollapsed"
                            class="main-nav-item main-nav-space-item"
                        >
                            <div
                                class="space-card"
                                :class="{ open: activeMenu === route.path }"
                                @click="handleLinkClick(route)"
                                @mouseenter="prefetchRoute(route)"
                            >
                                <div class="space-card-icon" v-html="route.meta.icon"></div>
                                <div class="space-card-body">
                                    <div class="space-card-name">
                                        {{ route.meta.title }}
                                        <span v-if="route.meta.spaceStatus === 'draft'" class="space-card-draft">{{ $t('Draft') }}</span>
                                    </div>
                                </div>
                                <button
                                    v-if="canEditSpace(route.meta.spaceId)"
                                    type="button"
                                    class="space-card-edit"
                                    :title="$t('Edit workgroup')"
                                    @click.stop="openSpaceEdit(route.meta.spaceId)"
                                >
                                    <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                                        <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/>
                                        <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/>
                                    </svg>
                                    {{ $t('Edit') }}
                                </button>
                            </div>
                            <ul :class="{ 'open': activeMenu === route.path }" class="sub-menu space-sub-menu">
                                <li
                                    v-for="childRoute in (route.children || []).filter(child => child.meta && child.show_in_menu === true && hasAccessToRoute(child))"
                                    :key="childRoute.name"
                                    :class="{ 'main-nav-sub-menu-item': true, 'router-link-active': isActiveChild(childRoute) }"
                                >
                                    <router-link :to="getChildPath(route, childRoute.path)" class="main-nav-sub-menu-item-link" @mouseenter="prefetchRoute(childRoute)">
                                        <span class="font-size-text-md font-weight-semibold" :class="{ 'active': isActiveChild(childRoute) }">
                                            {{ $t(childRoute.meta.title) }}
                                        </span>
                                    </router-link>
                                </li>
                                <li
                                    v-if="canEditSpace(route.meta.spaceId)"
                                    class="main-nav-sub-menu-item space-add-page"
                                >
                                    <a href="#" class="main-nav-sub-menu-item-link" @click.prevent="addPageToSpace(route.meta.spaceId, route.path)">
                                        <span class="font-size-text-md font-weight-semibold">
                                            <span class="space-add-icon">+</span>
                                            {{ $t('Add page') }}
                                        </span>
                                    </a>
                                </li>
                            </ul>
                        </li>

                        <!-- Standard nav item -->
                        <li v-else class="main-nav-item">
                            <template v-if="hasAccessToRoute(route)">
                            <a
                                @click.prevent="handleLinkClick(route)"
                                @mouseenter="prefetchRoute(route)"
                                :class="['main-nav-item-link', { 'expandable': hasChildren(route), 'open': activeMenu === route.path, 'active': !hasChildren(route) && $route.path === route.path }]"
                                :href="route.path"
                                class="icon-leading"
                            >
                                <div v-if="route.meta" class="main-nav-item-link-content">
                                <div v-html="route.meta.icon" class="icon"></div>
                                <span class="font-size-text-md font-weight-semibold">{{ $t(route.meta.title) }}</span>
                                <svg v-if="route.children" width="20" height="20" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                                    <g>
                                    <path fill="none" d="M0 0h24v24H0z"></path>
                                    <path d="M12 13.172l4.95-4.95 1.414 1.414L12 16 5.636 9.636 7.05 8.222z"></path>
                                    </g>
                                </svg>
                                </div>
                            </a>
                            <!-- Regular submenu for expanded state -->
                            <ul v-if="route.children && !isCollapsed" :class="{ 'open': activeMenu === route.path }" class="sub-menu">
                                <li v-for="childRoute in route.children.filter(child => child.meta && child.show_in_menu === true && hasAccessToRoute(child))"
                                :key="childRoute.name"
                                :class="{ 'main-nav-sub-menu-item': true, 'router-link-active': isActiveChild(childRoute) }"
                                >

                                <router-link  :to="getChildPath(route, childRoute.path)" class="main-nav-sub-menu-item-link" @mouseenter="prefetchRoute(childRoute)">
                                    <span class="font-size-text-md font-weight-semibold" :class="{ 'active': isActiveChild(childRoute) }">
                                    {{ $t(childRoute.meta.title) }}
                                    </span>
                                </router-link>


                                </li>
                            </ul>
                            <!-- Flyout submenu for collapsed state -->
                            <div v-if="route.children && isCollapsed" class="flyout-wrapper">
                                <div class="flyout-menu">
                                    <div class="flyout-header">{{ $t(route.meta.title) }}</div>
                                    <ul class="flyout-list">
                                        <li v-for="childRoute in route.children.filter(child => child.meta && child.show_in_menu === true && hasAccessToRoute(child))"
                                        :key="childRoute.name"
                                        :class="{ 'flyout-item': true, 'active': isActiveChild(childRoute) }"
                                        >
                                        <router-link :to="getChildPath(route, childRoute.path)" class="flyout-link" @mouseenter="prefetchRoute(childRoute)">
                                            {{ $t(childRoute.meta.title) }}
                                        </router-link>
                                        </li>
                                    </ul>
                                </div>
                            </div>
                            </template>
                        </li>
                        </template>
                        </ul>

                </div>
                <div class="main-nav-content-inner main-nav-extras-outer">
    
                  
                    <div v-if="alerts.status === 'active'" class="alert">
                        <div class="alert-header">
                            <span class="title">⚡️ {{ $i18n.locale === 'de-DE' ? (alerts.translations && alerts.translations[0]?.title) || alerts.title : alerts.title }}</span>
                        </div>
                        <span v-html="$i18n.locale === 'de-DE' ? (alerts.translations && alerts.translations[0]?.message) || alerts.message : alerts.message" class="message"></span>
                    </div>

                    <ul class="main-nav-list main-nav-extras-inner">
                        <li class="main-nav-item">
                            <router-link to="/notifications" :class="['main-nav-item-link', 'icon-leading', { 'active': $route.path === '/notifications' }]" @mouseenter="prefetchRouteByPath('/notifications')">
                                <div class="main-nav-item-link-content">
                                    <div class="badge-container">

                                        <span v-if="notificationsCount !== 0" v-html="notificationsCount" class="badge"></span>
                                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M9.35419 21C10.0593 21.6224 10.9856 22 12 22C13.0145 22 13.9407 21.6224 14.6458 21M18 8C18 6.4087 17.3679 4.88258 16.2427 3.75736C15.1174 2.63214 13.5913 2 12 2C10.4087 2 8.8826 2.63214 7.75738 3.75736C6.63216 4.88258 6.00002 6.4087 6.00002 8C6.00002 11.0902 5.22049 13.206 4.34968 14.6054C3.61515 15.7859 3.24788 16.3761 3.26134 16.5408C3.27626 16.7231 3.31488 16.7926 3.46179 16.9016C3.59448 17 4.19261 17 5.38887 17H18.6112C19.8074 17 20.4056 17 20.5382 16.9016C20.6852 16.7926 20.7238 16.7231 20.7387 16.5408C20.7522 16.3761 20.3849 15.7859 19.6504 14.6054C18.7795 13.206 18 11.0902 18 8Z" stroke="#667085" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                                    </div>
                                    <span style="padding-bottom:5px" class="font-size-text-md font-weight-semibold">{{ $t("Inbox") }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li class="main-nav-item">
                            <router-link to="/settings" :class="['main-nav-item-link', 'icon-leading', { 'active': $route.path === '/settings' }]" @mouseenter="prefetchRouteByPath('/settings')">
                                <div class="main-nav-item-link-content">
                                    <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path fill="none" d="M0 0h24v24H0z"></path><path d="M2 12c0-.865.11-1.703.316-2.504A3 3 0 0 0 4.99 4.867a9.99 9.99 0 0 1 4.335-2.505 3 3 0 0 0 5.348 0 9.99 9.99 0 0 1 4.335 2.505 3 3 0 0 0 2.675 4.63c.206.8.316 1.638.316 2.503 0 .865-.11 1.703-.316 2.504a3 3 0 0 0-2.675 4.629 9.99 9.99 0 0 1-4.335 2.505 3 3 0 0 0-5.348 0 9.99 9.99 0 0 1-4.335-2.505 3 3 0 0 0-2.675-4.63C2.11 13.704 2 12.866 2 12zm4.804 3c.63 1.091.81 2.346.564 3.524.408.29.842.541 1.297.75A4.993 4.993 0 0 1 12 18c1.26 0 2.438.471 3.335 1.274.455-.209.889-.46 1.297-.75A4.993 4.993 0 0 1 17.196 15a4.993 4.993 0 0 1 2.77-2.25 8.126 8.126 0 0 0 0-1.5A4.993 4.993 0 0 1 17.195 9a4.993 4.993 0 0 1-.564-3.524 7.989 7.989 0 0 0-1.297-.75A4.993 4.993 0 0 1 12 6a4.993 4.993 0 0 1-3.335-1.274 7.99 7.99 0 0 0-1.297.75A4.993 4.993 0 0 1 6.804 9a4.993 4.993 0 0 1-2.77 2.25 8.126 8.126 0 0 0 0 1.5A4.993 4.993 0 0 1 6.805 15zM12 15a3 3 0 1 1 0-6 3 3 0 0 1 0 6zm0-2a1 1 0 1 0 0-2 1 1 0 0 0 0 2z"></path></g></svg>
                                    <span class="font-size-text-md font-weight-semibold">{{ $t("Settings") }}</span>
                                </div>
                            </router-link>
                        </li>
                        <li v-if="canAccessAdmin && adminRoute" class="main-nav-item">
                            <router-link to="/admin" :class="['main-nav-item-link', 'icon-leading', { 'active': $route.path.startsWith('/admin') }]" @mouseenter="prefetchRouteByPath('/admin')">
                                <div class="main-nav-item-link-content">
                                    <div v-html="adminRoute.meta.icon" class="icon"></div>
                                    <span class="font-size-text-md font-weight-semibold">{{ $t('Admin') }}</span>
                                </div>
                            </router-link>
                        </li>
                    </ul>
                    <div class="divider"></div>
                    
                    <div class="main-nav-user-container">
                        <div class="main-nav-user-inner">
                            <div class="avatar">
                                <a class="avatar-link">
                                    <img v-if="userStore.user" :src="apiUrl+'/assets/'+userStore.user.avatar" loading="lazy" />
                                </a>
                            </div>
                            <div class="main-nav-user-info">
                                <span v-if="userStore.user" class="font-size-text-sm font-weight-semibold">{{userStore.user.first_name}} {{userStore.user.last_name}}</span>
                                <span v-if="userStore.user" class="font-size-text-xs text-gray-600">{{userStore.user.title}}</span>
                                <span class="build-stamp" :title="buildTime ? `Built ${buildTime}` : 'dev'">
                                    v{{ version }}
                                </span>
                            </div>
                        </div>
                    </div>

                </div>
             
            </div>
            <div class="mobile-nav-overlay"></div>
        </nav>
    </div>
    <span @click="toggleMobileMenu" class="cs-btn secondary icon-only mobile-toggle">
        <svg width="24" height="24" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><g><path fill="none" d="M0 0h24v24H0z"></path><path d="M3 4h18v2H3V4zm6 7h12v2H9v-2zm-6 7h18v2H3v-2z"></path></g></svg>
    </span>

    <EditSpaceModal
        v-if="editingSpace"
        :space="editingSpace"
        @close="editingSpace = null"
        @saved="onSpaceSaved"
    />
</template>


<script>
import { useUserStore } from "../../store/user.js";
import { useCollectionsStore } from "../../store/collections.js";
import { useRouter } from 'vue-router';
import router from '../../router/index.js';
import directus, { useRealtimeSubscription } from '../../composables/useDirectus.js';
import useNotification  from '../../composables/useNotification.js';
import { useSpaces } from '../../composables/useSpaces.js';
import { LANDING_SLUG } from '../../composables/useSpacePages.js';
import EditSpaceModal from '../../views/spaces/components/EditSpaceModal.vue';
import { useDialog } from '../../composables/useDialog.js';
import { slugify } from '../../composables/useSlug.js';
import { onMounted, onBeforeUnmount } from 'vue';
const { VITE_apiUrl: apiUrl } = import.meta.env;

export default {
    data() {
        return {
            activeMenu: '',
            version: import.meta.env.VITE_APP_VERSION,
            buildTime: import.meta.env.VITE_BUILD_TIME || '',
            routes: router.options.routes,
            showMobileMenu: false,
            contentWidth: 1000,
            isPageVisible: document.visibilityState === 'visible',
            alert: false,
            pollingInterval: null,
            alertSubscription: null,
            alertReconnectTimer: null,
            alertReconnectAttempts: 0,
            alerts: [],
            alertSend: false,
            apiUrl,
            currentTheme: 'light',
            isCollapsed: false,
            spaces: [],
            spacePages: [],
            editingSpace: null
        };
    },
    components: {
        EditSpaceModal
    },
    methods:{
        hasChildren(route) {
            return route.children && route.children.length > 0;
        },

        isActiveChild(childRoute) {
            // Use exact path matching to avoid false positives
            // e.g., "photo-requests" should not match "requests"
            const currentPath = this.$route.path;
            const childPath = childRoute.path;

            // Check if the current path ends with /childPath or /childPath/something
            const pathSegments = currentPath.split('/').filter(Boolean);
            return pathSegments.includes(childPath) || currentPath.endsWith('/' + childPath);
        },
        setMenu(path) {
            this.activeMenu = path;
        },
        handleLinkClick(route) {
            // Workgroup parents have a real landing path (`/spaces/<slug>`) that
            // either redirects to the first page or shows the empty-state — so
            // a click should always navigate AND keep the submenu open. Plain
            // routes with children (Company, Productivity) only redirect to /,
            // so for those we keep the legacy toggle behaviour.
            if (route.meta?.isSpace) {
                this.activeMenu = route.path;
                const currentPath = this.$route.path;
                if (currentPath !== route.path && !currentPath.startsWith(route.path + '/')) {
                    this.$router.push(route.path);
                }
                return;
            }
            if (this.hasChildren(route)) {
                // In collapsed state, do nothing - flyout handles navigation
                if (!this.isCollapsed) {
                    // Toggle the menu
                    this.setMenu(route.path === this.activeMenu ? null : route.path);
                }
            } else {
                // Close any open submenu when clicking a route without children
                this.activeMenu = null;

                // Set the active sub-menu item based on the current route
                this.activeSubMenu = route.path;

                // Navigate to the specified route
                this.$router.push(route.path);
            }
        },
        hasAccessToRoute(route) {
            if (!route || !route.show_in_menu) {
                return false;
            }

            if (route.children) {
                return route.children.some(child => {
                    if (!child || !child.show_in_menu) {
                        return false;
                    }

                    if (child.meta && child.meta.collection) {
                        // Check if route requires full (unrestricted) access
                        if (child.meta.requiresFullAccess) {
                            return this.hasFullAccessToResource(child.meta.collection);
                        }
                        // Check if route requires write permissions
                        if (child.meta.requiresWrite) {
                            return this.hasWriteAccessToResource(child.meta.collection);
                        } else {
                            return this.hasAccessToResource(child.meta.collection);
                        }
                    }

                    return true;
                });
            }

            if (route.meta && route.meta.collection) {
                // Check if route requires full (unrestricted) access
                if (route.meta.requiresFullAccess) {
                    return this.hasFullAccessToResource(route.meta.collection);
                }
                // Check if route requires write permissions
                if (route.meta.requiresWrite) {
                    return this.hasWriteAccessToResource(route.meta.collection);
                } else {
                    return this.hasAccessToResource(route.meta.collection);
                }
            }

            return true;
        },
        hasAccessToResource(collection, permissionType = 'read') {
            const permissions = this.userStore.permissions;

            if (permissions && permissions[collection]) {
                const access = permissions[collection][permissionType];
                return access?.access !== 'none';
            }
            return false;
        },
        hasWriteAccessToResource(collection) {
            const permissions = this.userStore.permissions;

            if (permissions && permissions[collection]) {
                const createAccess = permissions[collection].create;
                const updateAccess = permissions[collection].update;
                return (createAccess?.access !== 'none' || updateAccess?.access !== 'none');
            }
            return false;
        },
        hasFullAccessToResource(collection) {
            // Check if user has FULL (unrestricted) write access to a collection
            // This excludes users who only have conditional access (e.g., "edit own user only")
            const permissions = this.userStore.permissions;

            if (permissions && permissions[collection]) {
                const createAccess = permissions[collection].create;
                const updateAccess = permissions[collection].update;
                const readAccess = permissions[collection].read;

                // Check if user has "full" access level (not conditional/limited)
                const hasFullCreate = createAccess?.access === 'full';
                const hasFullUpdate = updateAccess?.access === 'full';
                const hasFullRead = readAccess?.access === 'full';

                // User needs full read AND (full create OR full update) access
                return hasFullRead && (hasFullCreate || hasFullUpdate);
            }
            return false;
        },
        getChildPath(parentRoute, childPath) {
            // Ensure the parent route path ends with a slash
            const parentPath = parentRoute.path.endsWith('/') ? parentRoute.path : parentRoute.path + '/';
            return parentPath + childPath;
        },
        updateContentWidth() {
            this.contentWidth = window.innerWidth;
        },
        toggleMobileMenu() {
            this.showMobileMenu = !this.showMobileMenu;
        },
        handleVisibilityChange() {
            this.isPageVisible = document.visibilityState === 'visible';
        },
        async getAlerts(){
            const collectionsStore = useCollectionsStore();
            try {
                const { data } = await collectionsStore.fetch('orbit_alert', async () => {
                    return await directus.items('orbit_alert').readOne(1, {
                        fields: ['*','translations.*']
                    });
                });
                this.alerts = data;
            } catch (error) {

            }
        },
        async subscribeToAlerts() {
            const { subscribe } = useRealtimeSubscription();

            try {
                this.alertSubscription = await subscribe('orbit_alert', {
                    event: 'update',
                    query: {
                        fields: ['*', 'translations.*']
                    },
                    onData: (message) => {
                        if (message.data && message.data.length > 0) {
                            this.alerts = message.data[0];
                            useCollectionsStore().updateCache('orbit_alert', message.data[0]);
                        }
                    },
                    onError: (error) => {
                        console.warn('Alert WebSocket error, falling back to polling:', error);
                        this.startPollingFallback();
                        this.scheduleAlertReconnect();
                    }
                });
                // Subscription healthy — stop fallback polling and reset backoff.
                this.stopPollingFallback();
                this.alertReconnectAttempts = 0;
            } catch (error) {
                console.warn('Failed to subscribe to alerts, using polling fallback:', error);
                this.startPollingFallback();
                this.scheduleAlertReconnect();
            }
        },
        scheduleAlertReconnect() {
            if (this.alertReconnectTimer) return;
            // Exponential backoff: 30s, 2m, 5m, 10m (capped).
            const delays = [30_000, 120_000, 300_000, 600_000];
            const delay = delays[Math.min(this.alertReconnectAttempts, delays.length - 1)];
            this.alertReconnectAttempts += 1;
            this.alertReconnectTimer = setTimeout(async () => {
                this.alertReconnectTimer = null;
                if (this.alertSubscription) {
                    try { this.alertSubscription.unsubscribe(); } catch (_) { /* ignore */ }
                    this.alertSubscription = null;
                }
                await this.subscribeToAlerts();
            }, delay);
        },
        stopPollingFallback() {
            if (this.pollingInterval) {
                clearInterval(this.pollingInterval);
                this.pollingInterval = null;
            }
        },
        startPollingFallback() {
            // Only start polling if not already polling
            if (this.pollingInterval) return;
            let randomMinute = Math.random() * (20 - 15) + 15;
            this.pollingInterval = setInterval(this.getAlerts, randomMinute * 60 * 1000);
        },
        async getSpaces({ forceRefresh = false } = {}) {
            try {
                const { spaces, load } = useSpaces();
                await load({ includeDrafts: true, forceRefresh });
                this.spaces = spaces.value;
                await this.getSpacePages({ forceRefresh });
            } catch (error) {
                // Spaces are optional — fail silently if collection isn't accessible yet
            }
        },
        canEditSpace(spaceId) {
            // Membership-only check: admins technically retain server-side
            // write access, but UI affordances ("Edit", "+ Add page") are
            // hidden unless the user is actually a member of this workgroup.
            const space = this.spaces.find((s) => s.id === spaceId);
            if (!space) return false;
            const userId = useUserStore().user?.id;
            if (!userId || !space.members) return false;
            const m = space.members.find(
                (mem) => (mem.directus_users_id?.id || mem.directus_users_id) === userId
            );
            return m?.role === 'editor' || m?.role === 'owner';
        },
        openSpaceEdit(spaceId) {
            const space = this.spaces.find((s) => s.id === spaceId);
            if (space) this.editingSpace = space;
        },
        onSpaceSaved() {
            // Refresh spaces (and their pages) so any rename/icon/color shows immediately
            useCollectionsStore().invalidate('orbit_spaces_all');
            useCollectionsStore().invalidate('orbit_spaces');
            this.getSpaces();
        },
        async addPageToSpace(spaceId, basePath) {
            const dialog = useDialog();
            // Defensive — the click handler comes through route.meta which can
            // briefly be undefined while the sidebar re-renders after a save.
            const numericSpaceId = Number(spaceId);
            if (!Number.isFinite(numericSpaceId) || numericSpaceId <= 0) {
                console.error('addPageToSpace called without a valid spaceId', { spaceId, basePath });
                await dialog.confirm({
                    title: 'Could not add page',
                    message: 'No workgroup context. Try refreshing the sidebar.',
                    confirmLabel: 'OK',
                    cancelLabel: ''
                });
                return;
            }
            const result = await dialog.prompt({
                title: 'New page',
                label: 'Page title',
                placeholder: 'e.g. Health & safety',
                confirmLabel: 'Create',
                withSlug: {
                    label: 'URL slug',
                    placeholder: 'health-and-safety',
                    hint: 'Used in the page URL. Auto-generated from the title — edit if you want.',
                    fromValue: (v) => slugify(v)
                },
                validate: (p) => {
                    if (!p?.value?.trim()) return 'Please enter a title.';
                    if (!p?.slug?.trim()) return 'Slug cannot be empty.';
                    if (!/^[a-z0-9-]+$/.test(p.slug)) return 'Slug may only contain a-z, 0-9 and hyphens.';
                    return null;
                }
            });
            if (!result?.value?.trim()) return;
            const title = result.value.trim();
            const slug = result.slug.trim();
            const payload = {
                space_id: numericSpaceId,
                title,
                slug,
                parent_page_id: null,
                status: 'draft',
                sort: this.spacePages.filter((p) => p.space_id === numericSpaceId).length
            };
            console.log('[addPageToSpace] payload:', JSON.parse(JSON.stringify(payload)));
            try {
                await directus.items('orbit_space_pages').createOne(payload);
                const spaceIds = this.spaces.map((s) => s.id);
                useCollectionsStore().invalidate(`orbit_space_pages_nav_${spaceIds.join('_')}`);
                useCollectionsStore().invalidate(`orbit_space_pages_${numericSpaceId}`);
                await this.getSpacePages();
                this.$router.push(`${basePath}/${slug}`);
            } catch (e) {
                const apiMsg = e?.errors?.[0]?.message;
                console.error('Failed to create page', e);
                await dialog.confirm({
                    title: 'Could not create page',
                    message: apiMsg
                        ? `Directus rejected the request: ${apiMsg}`
                        : 'The slug may already be in use. Try a different title or slug.',
                    confirmLabel: 'OK',
                    cancelLabel: ''
                });
            }
        },
        async getSpacePages({ forceRefresh = false } = {}) {
            if (!this.spaces.length) {
                this.spacePages = [];
                return;
            }
            try {
                const collectionsStore = useCollectionsStore();
                const spaceIds = this.spaces.map(s => s.id);
                const cacheKey = `orbit_space_pages_nav_${spaceIds.join('_')}`;
                // No status filter — the Spaces policy already restricts drafts
                // to Space members server-side, so members see their drafts in the
                // nav while everyone else only sees published pages.
                const { data } = await collectionsStore.fetch(
                    cacheKey,
                    async () => {
                        const result = await directus.items('orbit_space_pages').readByQuery({
                            fields: ['id', 'space_id', 'parent_page_id', 'slug', 'title', 'status', 'sort'],
                            filter: { space_id: { _in: spaceIds } },
                            sort: ['parent_page_id', 'sort', 'title'],
                            limit: -1
                        });
                        return result.data || [];
                    },
                    { ttl: 15 * 60 * 1000, forceRefresh }
                );
                this.spacePages = data;
            } catch (error) {
                this.spacePages = [];
            }
        },
        toggleTheme() {
            // Toggle between light and dark
            this.currentTheme = this.currentTheme === 'light' ? 'dark' : 'light';

            // Save to localStorage
            localStorage.setItem('theme', this.currentTheme);

            // Apply theme
            const html = document.querySelector("html");
            html.setAttribute("data-theme", this.currentTheme);
        },
        updateActiveMenu() {
            const currentPath = this.$route.path;
            // Find which parent menu should be open based on current route.
            // Iterate filteredRoutes (not raw routes) so injected per-Space entries are considered.
            this.filteredRoutes.forEach((route) => {
                if (route.path !== '/' && currentPath.startsWith(route.path)) {
                    this.activeMenu = route.path;
                }
            });
        },
        toggleCollapse() {
            this.isCollapsed = !this.isCollapsed;
            localStorage.setItem('sidebarCollapsed', this.isCollapsed);
        },
        // Prefetch route component on hover for faster navigation
        prefetchRoute(route) {
            if (!route) return;

            // If route has a component that's a function (dynamic import), trigger it
            if (route.component && typeof route.component === 'function') {
                // Calling the function triggers the dynamic import
                route.component().catch(() => {
                    // Silently ignore prefetch errors
                });
            }
        },
        // Prefetch child route component
        prefetchChildRoute(parentRoute, childPath) {
            if (!parentRoute?.children) return;

            const childRoute = parentRoute.children.find(child => child.path === childPath);
            if (childRoute) {
                this.prefetchRoute(childRoute);
            }
        },
        // Prefetch route by path (for static links)
        prefetchRouteByPath(path) {
            const route = this.routes.find(r => r.path === path);
            if (route) {
                this.prefetchRoute(route);
            }
        }
    },
    watch: {
        '$route.path': {
            immediate: true,
            handler() {
                this.updateActiveMenu();
            }
        }
    },
    computed: {
        filteredRoutes() {
            // Admin is rendered separately in the bottom extras section, so exclude it from the top list.
            const baseRoutes = this.routes.filter(
                route => route.meta && route.show_in_menu === true && route.name !== 'admin'
            );
            // Inject one synthetic top-level entry per Space.
            if (!this.spaces || !this.spaces.length) return baseRoutes;

            const defaultSpaceIcon = '<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><rect x="3" y="3" width="7" height="7"/><rect x="14" y="3" width="7" height="7"/><rect x="14" y="14" width="7" height="7"/><rect x="3" y="14" width="7" height="7"/></svg>';
            // Skip archived spaces entirely (drafts stay so editors can ramp them up before publish)
            const visibleSpaces = this.spaces.filter(s => s.status !== 'archived');
            const spaceRoutes = visibleSpaces.map((space, idx) => {
                const topPages = (this.spacePages || [])
                    .filter(p => p.space_id === space.id && !p.parent_page_id && p.slug !== LANDING_SLUG)
                    .sort((a, b) => (a.sort ?? 0) - (b.sort ?? 0));
                return {
                    path: `/spaces/${space.slug}`,
                    name: `space.${space.slug}`,
                    show_in_menu: true,
                    meta: {
                        title: space.name,
                        icon: space.icon || defaultSpaceIcon,
                        spaceId: space.id,
                        spaceSlug: space.slug,
                        spaceStatus: space.status || 'draft',
                        isSpace: true,
                        isFirstSpace: idx === 0
                    },
                    children: topPages.length ? topPages.map(page => ({
                        path: page.slug,
                        name: `space.${space.slug}.${page.slug}`,
                        show_in_menu: true,
                        meta: { title: page.title }
                    })) : null
                };
            });

            return [...baseRoutes, ...spaceRoutes];
        },
        adminRoute() {
            return this.routes.find(r => r.name === 'admin') || null;
        },
        canAccessAdmin() {
            const userStore = useUserStore();
            const perms = userStore.permissions;
            // Treat "admin" link visibility as: any non-public-only role with write somewhere.
            // Simple check — if the user has full access on directus_users they're an admin.
            // Otherwise, content editors still see it (they can hit news/documents/polls).
            if (!perms) return false;
            const hasFull = perms?.directus_users?.update?.access === 'full';
            const canEditNews = ['full', 'partial'].includes(perms?.orbit_news?.update?.access);
            const canEditDocs = ['full', 'partial'].includes(perms?.orbit_documents?.update?.access);
            const canManagePortal = ['customers', 'customer_files', 'customer_info'].some((c) =>
                ['full', 'partial'].includes(perms?.[c]?.update?.access)
                || ['full', 'partial'].includes(perms?.[c]?.create?.access));
            return hasFull || canEditNews || canEditDocs || canManagePortal;
        },
        isDarkMode() {
            return this.currentTheme === 'dark';
        },
        themeLabel() {
            return this.currentTheme === 'light' ? 'Light Mode' : 'Dark Mode';
        }
    },
    mounted() {
        // Initialize theme from localStorage
        const savedTheme = localStorage.getItem('theme') || 'light';
        this.currentTheme = savedTheme;

        // Initialize collapsed state from localStorage
        const savedCollapsed = localStorage.getItem('sidebarCollapsed');
        this.isCollapsed = savedCollapsed === 'true';

        window.addEventListener('resize', this.updateContentWidth);
        this.updateContentWidth();

        // Initial fetch and subscribe to real-time updates
        this.getAlerts();
        this.subscribeToAlerts();

        // Spaces sidebar group — cache-respecting initial load.
        // Stale-while-revalidate in the cache + WS subscription below keep it
        // fresh; we no longer force-refresh here because that bypassed the
        // Pinia cache and caused a thundering herd alongside SpacePage /
        // SpaceLanding which also used to forceRefresh on mount.
        this.getSpaces();
    },
    setup() {
    	const userStore = useUserStore();
		const router = useRouter()
        const { getNotifications, notificationsCount, subscribeToNotifications, unsubscribeFromNotifications } = useNotification();

        onMounted(async () => {
            await getNotifications();
            // Subscribe to real-time notification updates
            subscribeToNotifications();
        });

        onBeforeUnmount(() => {
            unsubscribeFromNotifications();
        });

    	return { userStore,router,notificationsCount };
  	},
    created() {
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
    },
    destroyed() {
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.updateContentWidth);
        clearInterval(this.pollingInterval);
        if (this.alertReconnectTimer) {
            clearTimeout(this.alertReconnectTimer);
            this.alertReconnectTimer = null;
        }
        // Clean up WebSocket subscription
        if (this.alertSubscription) {
            this.alertSubscription.unsubscribe();
        }
    },
}
</script>

<style scoped>

.sidebarNav {
    height: 100vh;
    position: sticky;
    top: 0;
    /* `align-self: start` keeps the sidebar at its explicit 100vh height
       inside the grid; without it, the default `stretch` alignment fights
       with sticky and the sidebar can collapse on short pages. */
    align-self: start;
    transition: width 0.25s cubic-bezier(0.4, 0, 0.2, 1);
    width: 280px;
}

.sidebarNav.collapsed {
    width: 72px;
    overflow: visible;
    z-index: 100;
}

.main-nav {
    background: var(--cs-white);
    border-right: 1px solid var(--cs-gray-200);
    border-bottom: none;
    height: 100%;
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
}

.collapsed .main-nav {
    overflow: visible;
}

[data-theme="dark"] .main-nav {
    background: var(--cs-gray-800);
    border-right: 1px solid var(--cs-gray-700);
    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
}

.main-nav-content {
    display: flex;
    flex-direction: column;
    align-items: start;
    height: 100%;
    padding: 24px 16px 16px 16px;
    justify-content: space-between;
    min-width: 280px;
    transition: min-width 0.25s cubic-bezier(0.4, 0, 0.2, 1), padding 0.25s cubic-bezier(0.4, 0, 0.2, 1);
}

.collapsed .main-nav-content {
    min-width: 72px;
    padding: 24px 12px 16px 12px;
    align-items: center;
    overflow: visible;
}

.version{
    color: #0077bd;
}

[data-theme="dark"] .version {
    color: #419AD4;
}

.build-stamp {
    margin-top: 2px;
    color: var(--cs-gray-500, #9aa0a6);
    font-size: 9px;
    line-height: 1.2;
    letter-spacing: 0.02em;
    opacity: 0.65;
    user-select: text;
    cursor: help;
}

.collapsed .build-stamp {
    display: none;
}

[data-theme="dark"] .build-stamp {
    color: rgba(255, 255, 255, 0.4);
}

.main-nav-content-inner {
    display: flex;
    flex-direction: column;
    align-items: start;
    width: 100%;
    gap: 24px;
}

.main-nav-logo {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 8px;
}

.collapsed .main-nav-logo {
    flex-direction: column;
    gap: 12px;
}

.main-nav-logo .router-link-active{
    background: unset !important;
}

.main-nav-logo svg{
    height: 28px;
    flex-shrink: 0;
}

.cs-logo {
    display: flex;
    align-items: center;
}

[data-theme="dark"] .cs-logo svg path {
    fill: var(--cs-white);
}

/* Collapse Toggle Button */
.collapse-toggle {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 32px;
    height: 32px;
    border: none;
    background: transparent;
    border-radius: 8px;
    cursor: pointer;
    color: var(--cs-gray-400);
    transition: all 0.2s ease;
    flex-shrink: 0;
}

.collapse-toggle:hover {
    background: var(--cs-gray-100);
    color: var(--cs-gray-600);
}

[data-theme="dark"] .collapse-toggle:hover {
    background: var(--cs-gray-700);
    color: var(--cs-gray-300);
}

.main-nav-list {
    display: flex;
    flex-direction: column;
    gap: 2px;
    width: 100%;
}

.collapsed .main-nav-list {
    align-items: center;
}

.main-nav-item {
    list-style: none;
    display: flex;
    flex-direction: column;
    height: fit-content;
    border-radius: 8px;
    align-items: initial;
    padding: 0;
    width: 100%;
    position: relative;
}

.collapsed .main-nav-item {
    width: 48px;
    position: relative;
}

.main-nav-item:hover {
    border-radius: 8px;
    background: transparent!important;
}

/* ───── Workgroups section (overline + card) ───── */
.main-nav-spaces-overline {
    list-style: none;
    padding: 8px 10px 2px;
    margin-top: 4px;
    border-top: 1px solid var(--cs-gray-100, #E8EAEC);
    font-size: 10px;
    font-weight: 600;
    letter-spacing: 0.1em;
    text-transform: uppercase;
    color: var(--cs-gray-500, #808695);
}

[data-theme="dark"] .main-nav-spaces-overline {
    /* The light-mode divider used --cs-gray-100 which falls back to
       #E8EAEC — almost white on a dark sidebar. Use a much subtler tone. */
    border-top-color: var(--cs-gray-700);
    color: var(--cs-gray-400);
}

.main-nav-space-item {
    list-style: none;
    width: 100%;
}

/* Workgroup cards reuse the regular nav-item-link visual baseline so the
   sidebar reads as one coherent list. The .space-card extras (draft badge +
   hover Edit button) sit on top of that base. */
.space-card {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 5px 10px;
    background: var(--cs-white);
    border-radius: 6px;
    cursor: pointer;
    transition: background 0.15s ease, color 0.15s ease;
    position: relative;
    color: var(--cs-gray-700);
}

.space-card:hover {
    background: var(--cs-gray-50);
    color: var(--cs-gray-900);
}

.space-card.open {
    background: var(--cs-blue-50, #D1E6F6);
}

.space-card.open .space-card-name {
    color: var(--cs-brand-blue, #0077BD);
    font-weight: 600;
}

[data-theme="dark"] .space-card {
    background: var(--cs-gray-800);
    color: var(--cs-gray-300);
}

[data-theme="dark"] .space-card:hover {
    background: var(--cs-gray-700);
    color: var(--cs-gray-200);
}

[data-theme="dark"] .space-card.open {
    background: transparent;
}

[data-theme="dark"] .space-card.open .space-card-name {
    color: #4BA3D3;
}

.space-card-icon {
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    color: var(--cs-gray-500);
}

.space-card-icon svg {
    width: 16px;
    height: 16px;
}

.space-card-icon svg path,
.space-card-icon svg rect,
.space-card-icon svg circle {
    stroke: currentColor;
}

.space-card:hover .space-card-icon {
    color: var(--cs-gray-700);
}

.space-card.open .space-card-icon {
    color: var(--cs-brand-blue, #0077BD);
}

[data-theme="dark"] .space-card-icon {
    color: var(--cs-gray-400);
}

[data-theme="dark"] .space-card:hover .space-card-icon {
    color: var(--cs-gray-200);
}

.space-card-body {
    min-width: 0;
    flex: 1;
}

.space-card-name {
    font-size: 14px;
    font-weight: 500;
    color: inherit;
    line-height: 1.2;
    display: flex;
    align-items: center;
    gap: 6px;
}

.space-card-draft {
    font-size: 9px;
    font-weight: 600;
    letter-spacing: 0.06em;
    text-transform: uppercase;
    padding: 1px 5px;
    border-radius: 3px;
    background: var(--cs-gray-100, #E8EAEC);
    color: var(--cs-gray-600, #6C6F78);
}

.space-card-edit {
    appearance: none;
    border: 1px solid var(--cs-gray-100, #E8EAEC);
    background: white;
    border-radius: 6px;
    padding: 3px 8px;
    font: inherit;
    font-size: 11px;
    color: var(--cs-gray-600, #6C6F78);
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    gap: 4px;
    flex-shrink: 0;
    opacity: 0;
    transition: opacity 0.15s ease, color 0.15s ease, border-color 0.15s ease;
}

.space-card:hover .space-card-edit {
    opacity: 1;
}

.space-card-edit:hover {
    color: var(--cs-brand-blue, #0077BD);
    border-color: var(--cs-brand-blue, #0077BD);
}

.space-add-page .main-nav-sub-menu-item-link span {
    color: var(--cs-brand-blue, #0077BD) !important;
    font-weight: 500;
}

.space-add-icon {
    font-size: 14px;
    line-height: 1;
    width: 14px;
    text-align: center;
    color: var(--cs-brand-blue, #0077BD);
}

/* Workgroup-specific sub-menu tweaks; base layout (margins/padding/border)
   is inherited from `.sub-menu` so both sections stay in lockstep. */
.space-sub-menu {
    list-style: none;
    flex-direction: column;
}

.space-sub-menu .main-nav-sub-menu-item {
    list-style: none;
    margin: 0;
}

.space-sub-menu .main-nav-sub-menu-item-link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px 10px;
    border-radius: 5px;
    text-decoration: none;
    transition: background 0.15s ease, color 0.15s ease;
}

.space-sub-menu .main-nav-sub-menu-item-link:hover {
    background: var(--cs-gray-50, #F8F8F9);
}

.space-sub-menu .main-nav-sub-menu-item-link span {
    font-size: 13px;
    color: var(--cs-gray-700, #515A6E);
    display: flex;
    align-items: center;
    gap: 8px;
}

.space-sub-menu .router-link-active .main-nav-sub-menu-item-link {
    background: var(--cs-blue-50, #D1E6F6);
}

.space-sub-menu .router-link-active .main-nav-sub-menu-item-link span {
    color: var(--cs-brand-blue, #0077BD);
    font-weight: 500;
}

/* Dark-mode overrides for the workgroup submenu (same problem as the
   regular submenu — span text was inheriting --cs-gray-700). */
[data-theme="dark"] .space-sub-menu .main-nav-sub-menu-item-link span {
    color: var(--cs-gray-200);
}
[data-theme="dark"] .space-sub-menu .main-nav-sub-menu-item-link:hover {
    background: var(--cs-gray-700);
}
[data-theme="dark"] .space-sub-menu .main-nav-sub-menu-item-link:hover span {
    color: var(--cs-white);
}
[data-theme="dark"] .space-sub-menu .router-link-active .main-nav-sub-menu-item-link {
    background: rgba(75, 163, 211, 0.15);
}
[data-theme="dark"] .space-sub-menu .router-link-active .main-nav-sub-menu-item-link span {
    color: #6FB5D9;
}

[data-theme="dark"] .main-nav-item-link {
    background: var(--cs-gray-800);
}

.main-nav-item-link {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    gap: 10px;
    text-decoration: none;
    color: var(--cs-gray-700);
    width: 100%;
    background: var(--cs-white);
    border-radius: 6px;
    transition: background 0.15s ease, color 0.15s ease;
    position: relative;
    overflow: hidden;
}

/* Active state accent bar removed for the design-A look — use background tint instead */
.main-nav-item-link.open::before,
.main-nav-item-link.active::before {
    content: none;
}

.main-nav-item-link.open,
.main-nav-item-link.active {
    background: var(--cs-blue-50, #D1E6F6);
}

[data-theme="dark"] .main-nav-item-link.open,
[data-theme="dark"] .main-nav-item-link.active {
    background: transparent;
}

.main-nav-item-link.open .main-nav-item-link-content span,
.main-nav-item-link.active .main-nav-item-link-content span {
    color: #0077BD;
    font-weight: 600;
}

[data-theme="dark"] .main-nav-item-link.open .main-nav-item-link-content span,
[data-theme="dark"] .main-nav-item-link.active .main-nav-item-link-content span {
    color: #4BA3D3;
}

.main-nav-item-link.open .icon svg path,
.main-nav-item-link.active .icon svg path {
    stroke: #0077BD !important;
}

[data-theme="dark"] .main-nav-item-link.open .icon svg path,
[data-theme="dark"] .main-nav-item-link.active .icon svg path {
    stroke: #4BA3D3 !important;
}

.main-nav-item-link-content {
    display: flex;
    gap: 10px;
    align-items: center;
    flex: 1;
    min-width: 0;
}

.main-nav-item-link-content span {
    font-size: 14px !important;
    font-weight: 500 !important;
    letter-spacing: 0;
}

.main-nav-item-link.open .main-nav-item-link-content span,
.main-nav-item-link.active .main-nav-item-link-content span {
    font-weight: 600 !important;
}

/* Hide text labels when collapsed */
.collapsed .main-nav-item-link-content span {
    display: none;
}

.collapsed .main-nav-item-link {
    justify-content: center;
    padding: 12px;
    width: 48px;
    height: 48px;
    margin: 0 auto;
}

.collapsed .main-nav-item-link-content {
    justify-content: center;
    gap: 0;
}

/* Hide chevron when collapsed.
   The chevron lives at `.main-nav-item-link-content > span + svg` — i.e.
   an SVG that comes immediately after the title `<span>`. We use the
   adjacent-sibling combinator deliberately because Settings/Inbox/Admin
   render their icon as a DIRECT child SVG of `.main-nav-item-link-content`
   (no wrapping `.icon` div), so a plain `> svg` selector would also hide
   their icons. The Settings/Inbox icon always sits BEFORE the span, the
   chevron always AFTER — `span + svg` matches only the latter. */
.collapsed .main-nav-item-link > svg,
.collapsed .main-nav-item-link-content > span + svg {
    display: none;
}

.main-nav-item-link-content .icon,
.main-nav-item-link-content .badge-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 16px;
    height: 16px;
    flex-shrink: 0;
}

/* Target both wrapped (.icon > svg) and direct-child SVGs so the
   Inbox/Settings/Admin entries shrink along with the regular nav. */
.main-nav-item-link-content .icon svg,
.main-nav-item-link-content > svg,
.main-nav-item-link-content .badge-container svg {
    width: 16px !important;
    height: 16px !important;
    min-width: 16px;
    min-height: 16px;
}

.main-nav-item-link-content .icon svg path {
    fill: none;
    stroke: var(--cs-gray-500);
    stroke-width: 2;
}

.main-nav-item-link-content .icon svg path[fill="none"] {
    fill: none;
}

/* Previously here: a dark-mode rule that forced
   `.main-nav-item-link-content .icon svg path { fill: none; stroke: var(--cs-gray-400); }`.
   That converted every filled icon into an outlined one in dark mode,
   which looked strange (icons drawn as filled shapes became thin
   outlines). Removed so dark mode inherits the icons' natural fill /
   stroke from the SVG markup, matching light-mode appearance. */

.main-nav-item-link-content span {
    color: var(--cs-gray-700);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

[data-theme="dark"] .main-nav-item-link span {
    color: var(--cs-gray-300);
}

.main-nav-item-link path:nth-of-type(2) {
    fill: var(--cs-gray-500);
}

.main-nav-item-link.expandable {
    justify-content: space-between;
}

/* Chevron icon */
.main-nav-item-link > svg {
    flex-shrink: 0;
    color: var(--cs-gray-400);
    transition: transform 0.2s ease;
}

.main-nav-item-link > svg path {
    fill: var(--cs-gray-400);
}

[data-theme="dark"] .main-nav-item-link {
    color: var(--cs-gray-300);
}

[data-theme="dark"] .main-nav-item-link path:nth-of-type(2) {
    fill: var(--cs-gray-300);
}

.main-nav-item-link:hover {
    background: var(--cs-gray-50);
    color: var(--cs-gray-900);
    cursor: pointer;
}

.main-nav-item-link:hover .icon svg path {
    stroke: var(--cs-gray-700);
}

[data-theme="dark"] .main-nav-item-link:hover {
    background: var(--cs-gray-700);
}

/* Previously here: a dark-mode hover rule that re-stroked the icon
   (`stroke: var(--cs-gray-200)`). Removed alongside the broad stroke
   override above — without that base rule, the icon's natural fill is
   preserved on hover too. */

.main-nav-item-link:focus {
    color: var(--cs-gray-900);
    outline: none;
}

[data-theme="dark"] .main-nav-item-link:focus {
    background: var(--cs-gray-700);
}

.main-nav-button-container {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    overflow: hidden;
}

.avatar img {
    width: 100%;
}

.mobile-toggle {
    display: none!important;
}

.main-nav-list {
    display: inherit;
    width: 100%;
}

.main-nav-extras-inner {
    width: 100%;
    align-items: start;
}

/* Hide extras text labels when collapsed */
.collapsed .main-nav-extras-inner .main-nav-item-link-content span {
    display: none;
}

.collapsed .main-nav-extras-inner .main-nav-item-link {
    justify-content: center;
    padding: 12px;
    width: 48px;
    height: 48px;
    margin: 0 auto;
}

.collapsed .main-nav-extras-inner .main-nav-item-link-content {
    justify-content: center;
    gap: 0;
}

/* Hide theme toggle label when collapsed */
.collapsed .theme-toggle-label-with-icon span {
    display: none;
}

.collapsed .theme-toggle-container {
    justify-content: center;
    padding: 12px;
    width: 48px;
    height: 48px;
    margin: 0 auto;
    border-radius: 8px;
}

.collapsed .theme-toggle-label-with-icon {
    gap: 0;
}

.collapsed .theme-toggle-label-with-icon svg {
    width: 24px;
    height: 24px;
}

.collapsed .theme-toggle-switch {
    display: none;
}

/* Hide alert when collapsed */
.collapsed .alert {
    display: none;
}

/* Hide divider when collapsed */
.collapsed .divider {
    display: none;
}

.main-nav-user-container {
    display: flex;
    width: 100%;
    gap: 12px;
    justify-content: space-between;
}

.collapsed .main-nav-user-container {
    justify-content: center;
}

.main-nav-user-inner {
    display: flex;
    gap: 12px
}

.collapsed .main-nav-user-inner {
    gap: 0;
}

.main-nav-user-info {
    display: flex;
    flex-direction: column;
    max-width: 180px;
}

/* Hide user info when collapsed */
.collapsed .main-nav-user-info {
    display: none;
}

.main-nav-user-info span {
    color: var(--cs-gray-700);
}

[data-theme="dark"] .main-nav-user-info span {
    color: var(--cs-gray-300);
}

.main-nav-user-info .text-gray-600 {
    color: var(--cs-gray-600);
}

[data-theme="dark"] .main-nav-user-info .text-gray-600 {
    color: var(--cs-gray-400);
}

.log-out-btn {
    height: 44px;
}

.mobile-toggle {
    display: block;
    position: absolute;
    top: 20px;
    right: 20px;
}

@media (max-width:800px) {
    .mobile-toggle {
        z-index: 99999;
        display: inline-block!important;
    }

    main {
        display: block;
    }

    .sidebarNav {
        position: absolute;
        width: 100%;
        z-index: 9999;
        height: 100vh;
        overflow: hidden;
        display: inline-block;
    }

}

.sub-menu {
    max-height: 0;
    overflow: hidden;
    transition: max-height 0.25s ease-out;
    margin: 2px 0 2px 16px;
    padding: 0 0 0 12px;
    border-left: 1px solid var(--cs-gray-100, #E8EAEC);
    list-style: none;
    gap: 2px;
}

[data-theme="dark"] .sub-menu {
    border-left-color: var(--cs-gray-700);
}

.sub-menu.open {
    display: flex;
    flex-direction: column;
    max-height: 504px;
    transition: max-height 0.25s ease-in;
}

/* Flyout Menu for Collapsed State */
.flyout-wrapper {
    display: none;
}

.collapsed .flyout-wrapper {
    display: block;
    position: absolute;
    left: 48px;
    top: -8px;
    padding: 8px 0 8px 16px;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    z-index: 9999;
}

.collapsed .main-nav-item:hover .flyout-wrapper {
    opacity: 1;
    visibility: visible;
    pointer-events: auto;
}

.flyout-menu {
    min-width: 200px;
    background: var(--cs-white);
    border-radius: 8px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
    border: 1px solid var(--cs-gray-200);
    overflow: hidden;
}

[data-theme="dark"] .flyout-menu {
    background: var(--cs-gray-800);
    border-color: var(--cs-gray-700);
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.4);
}

.flyout-header {
    padding: 12px 16px;
    font-size: 12px;
    font-weight: 600;
    color: var(--cs-gray-500);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    border-bottom: 1px solid var(--cs-gray-100);
}

[data-theme="dark"] .flyout-header {
    color: var(--cs-gray-400);
    border-bottom-color: var(--cs-gray-700);
}

.flyout-list {
    padding: 8px 0;
    margin: 0;
    list-style: none;
}

.flyout-item {
    margin: 0;
}

.flyout-link {
    display: block;
    padding: 10px 16px;
    color: var(--cs-gray-700);
    text-decoration: none;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.15s ease;
}

.flyout-link:hover {
    background: var(--cs-gray-50);
    color: var(--cs-gray-900);
}

[data-theme="dark"] .flyout-link {
    color: var(--cs-gray-300);
}

[data-theme="dark"] .flyout-link:hover {
    background: var(--cs-gray-700);
    color: var(--cs-white);
}

.flyout-item.active .flyout-link {
    color: #0077BD;
    background: rgba(0, 119, 189, 0.08);
    font-weight: 600;
}

[data-theme="dark"] .flyout-item.active .flyout-link {
    color: #4BA3D3;
    background: rgba(0, 119, 189, 0.15);
}


.main-nav-item-link svg:nth-child(2) {
    transition: transform 0.2s ease;
}

.main-nav-item-link.open svg:nth-child(2) {
    transform: rotate(-180deg);
}

[data-theme="dark"] .main-nav-sub-menu-item a{
    background:unset;
}

.main-nav-sub-menu-item {
    position: relative;
    list-style: none;
    margin: 0;
}

.main-nav-sub-menu-item a,
.main-nav-sub-menu-item-link {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px 10px;
    text-decoration: none;
    color: var(--cs-gray-700, #515A6E);
    width: 100%;
    background: transparent;
    border-radius: 5px;
    transition: background 0.15s ease, color 0.15s ease;
}

.main-nav-sub-menu-item-link span,
.main-nav-sub-menu-item a span {
    font-size: 13px !important;
    font-weight: 500 !important;
    color: var(--cs-gray-700, #515A6E);
    display: flex;
    align-items: center;
    gap: 8px;
}


/* Active submenu item — tinted background + brand colour */
.main-nav-sub-menu-item.router-link-active a,
.main-nav-sub-menu-item.router-link-active .main-nav-sub-menu-item-link {
    background: var(--cs-blue-50, #D1E6F6);
    color: var(--cs-brand-blue, #0077BD);
}

.main-nav-sub-menu-item.router-link-active a span,
.main-nav-sub-menu-item.router-link-active .main-nav-sub-menu-item-link span {
    color: var(--cs-brand-blue, #0077BD);
    font-weight: 600 !important;
}


.main-nav-sub-menu-item:hover a,
.main-nav-sub-menu-item:hover .main-nav-sub-menu-item-link {
    background: var(--cs-gray-50, #F8F8F9);
    color: var(--cs-gray-900);
    cursor: pointer;
}

[data-theme="dark"] .main-nav-sub-menu-item a,
[data-theme="dark"] .main-nav-sub-menu-item-link {
    color: var(--cs-gray-200);
}

/* The text inside submenu items lives in a <span> with its own light-mode
   colour (--cs-gray-700). That declaration leaked into dark mode and made
   the text barely legible — explicitly override the span colour here. */
[data-theme="dark"] .main-nav-sub-menu-item a span,
[data-theme="dark"] .main-nav-sub-menu-item-link span {
    color: var(--cs-gray-200);
}

[data-theme="dark"] .main-nav-sub-menu-item:hover a,
[data-theme="dark"] .main-nav-sub-menu-item:hover .main-nav-sub-menu-item-link {
    background: var(--cs-gray-700);
    color: var(--cs-white);
}
[data-theme="dark"] .main-nav-sub-menu-item:hover a span,
[data-theme="dark"] .main-nav-sub-menu-item:hover .main-nav-sub-menu-item-link span {
    color: var(--cs-white);
}

[data-theme="dark"] .main-nav-sub-menu-item.router-link-active a,
[data-theme="dark"] .main-nav-sub-menu-item.router-link-active .main-nav-sub-menu-item-link {
    background: rgba(75, 163, 211, 0.15);
    color: #6FB5D9;
}

[data-theme="dark"] .main-nav-sub-menu-item.router-link-active a span,
[data-theme="dark"] .main-nav-sub-menu-item.router-link-active .main-nav-sub-menu-item-link span {
    color: #6FB5D9;
}

.external-link {
    display: flex;
    align-items: center;
    gap: 8px;
}

.external-link svg path:nth-of-type(2) {
    fill: var(--cs-gray-400)
}

[data-theme="dark"] .router-link-active{
    background-color: unset !important
}
.router-link-active {
  background-color: var(--cs-gray-50);
}

.router-link-active:hover {
  background-color: var(--cs-gray-100);
}

.router-link-active a {
    background-color: transparent;
}

.router-link-active a {
    background-color: transparent;
}

.alert{
    display: flex;
    padding: 20px 16px;
    flex-direction: column;
    align-items: flex-start;
    gap: 5px;
    align-self: stretch;
    border-radius: 8px;
    background: #0077bd;
}

.alert-header{
    display: flex;
    justify-content: space-between;
    flex-direction: row;
    width: 100%;
}

.alert-header .title{
    color: white;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 600;
    line-height: 20px;
}


.alert .message{
    color: white;
    font-family: Inter;
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px; 
}

.badge-container{
    position: relative;
}

.badge-container svg{
    margin-top: 6px;
}

.badge-container svg path[stroke="#667085"] {
    stroke: var(--cs-gray-500);
}

[data-theme="dark"] .badge-container svg path[stroke="#667085"],
[data-theme="dark"] .badge-container svg path {
    stroke: var(--cs-gray-300) !important;
}

.main-nav-item-link svg path[stroke="#667085"] {
    stroke: var(--cs-gray-500);
}

[data-theme="dark"] .main-nav-item-link svg path[stroke="#667085"] {
    stroke: var(--cs-gray-300) !important;
}

.badge-container .badge{
    position: absolute;
    top: -2px;
    right: -4px;
    z-index: 1;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: max-content;
    min-width: 16px;
    height: 16px;
    padding: 0 5px;
    color: white;
    font-weight: 800;
    font-size: 9px;
    background-color: #e35169;
    border-radius: 16px;
}

/* Theme Toggle Switch */
.theme-toggle-item {
    padding: 0 !important;
}

.theme-toggle-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    padding: 8px 12px;
    border-radius: var(--border-rad-md);
    background: transparent;
    transition: background 0.2s;
}

[data-theme="dark"] .theme-toggle-container {
    background: transparent;
}

.theme-toggle-container:hover {
    background: var(--cs-gray-50);
}

[data-theme="dark"] .theme-toggle-container:hover {
    background: var(--cs-gray-700);
}

.theme-toggle-label-with-icon {
    display: flex;
    align-items: center;
    gap: 12px;
}

.theme-toggle-label-with-icon svg path {
    stroke: var(--cs-gray-500);
}

[data-theme="dark"] .theme-toggle-label-with-icon svg path {
    stroke: var(--cs-gray-300);
}

.theme-toggle-label-with-icon span {
    color: var(--cs-gray-700);
}

[data-theme="dark"] .theme-toggle-label-with-icon span {
    color: var(--cs-gray-300);
}

.theme-toggle-switch {
    position: relative;
    width: 52px;
    height: 28px;
    border-radius: 14px;
    cursor: pointer;
    transition: all 0.3s ease;
}

.theme-toggle-track {
    position: absolute;
    inset: 0;
    border-radius: 14px;
    background: var(--cs-gray-200);
    transition: background 0.3s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 6px;
}

[data-theme="dark"] .theme-toggle-track {
    background: var(--cs-gray-600);
}

.theme-toggle-switch.is-dark .theme-toggle-track {
    background: #0077bd;
}

.theme-toggle-icon {
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--cs-gray-400);
    transition: color 0.3s ease;
    z-index: 1;
}

.theme-icon-sun {
    color: #f59e0b;
}

.theme-toggle-switch.is-light .theme-icon-sun {
    color: #ffffff;
}

.theme-icon-moon {
    color: var(--cs-gray-400);
}

.theme-toggle-switch.is-dark .theme-icon-moon {
    color: #ffffff;
}

.theme-toggle-thumb {
    position: absolute;
    top: 2px;
    left: 2px;
    width: 24px;
    height: 24px;
    border-radius: 12px;
    background: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.2);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    z-index: 2;
}

.theme-toggle-switch.is-dark .theme-toggle-thumb {
    transform: translateX(24px);
}

.theme-toggle-switch:active .theme-toggle-thumb {
    width: 28px;
}

.theme-toggle-switch.is-dark:active .theme-toggle-thumb {
    transform: translateX(20px);
}

</style>
